module.exports = __webpack_public_path__ + "img/uid-token-bg.f36ee476.png";